import { $1, $ } from "../utilities/selector"
import { FormValidator } from "./forms/validator"

export class Login {
  constructor() {
    this.formEl = $1('[data-js=login]');
    if (this.formEl) {
      this.init();
      this.bind();
      this.privacy();
    }
  }
  
  init() {
    this.loginButton = $1('[data-js="LoginButton"]', this.formEl);
    this.modal = $1('[data-modal="AccountModal"]');
    this.modalHeader = $1('h3', this.modal);
    this.modalBody = $1('.Modal-body',);
    this.modalFooter = $1('.Modal-footer',);
    this.consentField = $1('[data-js="Consent"]', this.formEl);
    $1('[name="UserName"]', this.formEl).focus();
  }

  clearModal() {
    window.document.body.classList.remove('has-modal');
    this.modal.classList.remove('is-open');
    setTimeout(() => {
      this.modalHeader.innerHTML = "";
      this.modalBody.innerHTML = "<p>Loading form...</p>";
      this.modalFooter.innerHTML = "";
    }, 500);
  }

  errorMessage(err) {
    this.modalHeader.innerHTML = "Error: " + err.status;
    this.modalBody.innerHTML = '<p>There has been an error, please try again later.</p>';
  }
  
  bind() {

    $1('[data-target="AccountModal"]', this.formEl).addEventListener('click', (e) => {
      fetch('/account/getforgottenpasswordform/')
        .then(response => {
            if (response.status !== 200) {
              throw response;
            }
            return response.json()
        })
        .then(response => {
          this.fetchResetPassword(response);
          this.postResetPassword();
        })
        .catch( (err) => {
          console.log(err)
          this.errorMessage(err);
        });
    });

    $1('[data-js="modal-close"]', this.modal).addEventListener('click', this.clearModal.bind(this));
  }

  fetchResetPassword(data) {
    this.modalHeader.innerHTML = data.formtitle;
    this.modalBody.innerHTML = '<form class="Login-reset" data-form="ForgotPassword">' + data.partialview.replace('<br />', '') + '</form>';
    this.modalFooter.innerHTML = "";

    let control = document.createElement('div');
    let field = $1('[name="EmailAddress"]', this.modalBody);
    let button = $1('input[type="button"]', this.modalBody);

    control.classList.add('Form-control');
    button.className = "Button Button--primary u-mt1";
    button.setAttribute("type", "submit");
    field.classList.add('Input');
    field.setAttribute("data-val", "");
    field.setAttribute("data-val-required", "Please provide a 'Email Address'");
    field.setAttribute("data-regex", "^[-\\w]+@[-\\w.]+\\.[-\\w]+$");
    field.setAttribute("data-val-regex", "Sorry, that is not a valid email address");
    field.parentNode.insertBefore(control, field);
    control.appendChild(field);
    field.focus();
  }

  postResetPassword() {
    let form = $1('[data-form="ForgotPassword"]')
    new FormValidator(form);
    
    form.addEventListener('submit', (e) => {
      
      if (e.defaultPrevented) return;
      
      form.setAttribute('disabled', true)
      
      let formData = new FormData();
      formData.append("email", $1('[name="EmailAddress"]').value);
      
      fetch('/account/ForgottenPassword/', {
        method: "POST",
        body: formData
      })
      .then(response => {
        if (response.status !== 200) {
          throw response;
        }
        return response.json()
      })
      .then(response => {
        this.modalBody.innerHTML = response.returnmessage
        if ( !response.success )
          form.setAttribute('disabled', false)
      })
      .catch((err) => {
        console.log(err)
        this.errorMessage(err);
      });
      
      e.preventDefault();
    });
  }

  privacy() {
    this.acceptButton = $1('[data-js="Privacy"]');
    
    if ( !this.acceptButton )
      return;

    this.loginButton.setAttribute('disabled', true);

    this.acceptButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.fetchPrivacyPolicy();
    });

    this.fetchPrivacyPolicy();
  }

  fetchPrivacyPolicy() {
    fetch('/policies/getprivacypolicy/')
      .then(response => {
        if (response.status !== 200) {
          throw response;
        }
        return response.json()
      })
      .then(response => {

        this.modalHeader.innerHTML = "Privacy Policy";
        this.modalBody.innerHTML = '<div id="privacycontent" class="cms">' + response.partialview + '</div>';
        this.modalFooter.innerHTML = '<button id="acceptBtn" class="Button Button-large Button--pass" data-js="Accept" data-content="Accept" disabled="true">Accept</button> <button id="rejectBtn" class="Button Button-large Button--fail" data-js="Reject" data-content="Reject">Reject</button>';

        window.document.body.classList.add('has-modal');
        this.modal.classList.add('is-open');

        let acceptFormButton = $1('[data-js="Accept"]', this.modal);
        let rejectFormButton = $1('[data-js="Reject"]', this.modal);
        let privacyContent = $1('#privacycontent');
        let errorEl = $1('.Form-error--password');

        acceptFormButton.addEventListener('click', () => {
          this.consentField.value = true;
          this.acceptButton.classList.add('Button--pass');
          this.acceptButton.classList.remove('Button--fail');
          errorEl.style.display = 'none';
          this.loginButton.removeAttribute('disabled');
          this.clearModal();
        });

        rejectFormButton.addEventListener('click', () => {
          this.consentField.value = false;
          this.clearModal();
        });

        this.modal.onscroll = (ev) => {
          if ( !this.modal.classList.contains('is-open') ) return;

          if ((this.modal.clientHeight + this.modal.scrollTop) >= privacyContent.offsetHeight) {
            acceptFormButton.removeAttribute('disabled');
            this.modal.onscroll = null;
          }
        };
      })
      .catch((err) => {
        console.log(err)
        this.errorMessage(err);
        window.document.body.classList.add('has-modal');
        this.modal.classList.add('is-open');
      });
  }
}

export default new Login();


// WEBPACK FOOTER //
// ./scripts/components/login.js